import React, { useContext } from 'react';
import { 
  MDBContainer, 
  MDBRow, 
  MDBCol, 
  MDBTypography, 
  MDBBtn, 
  MDBCard, 
  MDBCardBody, 
  MDBBadge,
  MDBAlert 
} from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { useStepNavigation } from '../hooks/useStepNavigation';
import { useValidation } from '../components/ValidationProvider';
import { useFormContext } from '../components/FormProvider';
import { DevContext } from '../../../../../App';

export default function CommunicateStep({ onComplete }) {
  const { t } = useTranslation();
  const { goToPreviousStep } = useStepNavigation();
  const { formData } = useFormContext();
  const { 
    isFormReadyToSave, 
    getValidationSummary, 
    validationResult,
    eventConfig
  } = useValidation();
  const { isDevMode } = useContext(DevContext);

  const validationSummary = getValidationSummary();

  const handleFinish = () => {
    if (isFormReadyToSave()) {
      onComplete?.();
      // Final step - could trigger submission
      console.log('Form ready for submission:', formData);
      console.log('Final validation result:', validationResult);
    } else {
      console.warn('Form not ready for submission:', validationSummary);
    }
  };

  return (
    <div className="d-flex flex-column h-100">
      <MDBContainer className="flex-grow-1 pb-5">
      <MDBTypography tag="h3" className="mb-4">
        {t('Communicate Registration')}
      </MDBTypography>
      
      <MDBRow className="mb-4">
        <MDBCol>
          <p>{t('Final step - communicate registration - to be implemented')}</p>
        </MDBCol>
      </MDBRow>

      {/* Final Validation Summary */}
      <MDBRow className="mb-4">
        <MDBCol>
          <MDBCard className="border-primary">
            <MDBCardBody>
              <MDBTypography tag="h5" className="mb-3">
                📤 Bereit für Übermittlung
              </MDBTypography>
              
              <div className="mb-3">
                <strong>Gesamtstatus:</strong>{' '}
                <MDBBadge color={validationSummary.isValid ? 'success' : 'danger'} size="lg">
                  {validationSummary.isValid ? 'Bereit für Übermittlung' : 'Nicht vollständig'}
                </MDBBadge>
              </div>
              
              {validationSummary.isValid ? (
                <MDBAlert color="success">
                  ✅ Alle Validierungen bestanden! Die Vortragsanmeldung kann übermittelt werden.
                </MDBAlert>
              ) : (
                <MDBAlert color="danger">
                  ❌ {validationSummary.totalErrors} Validierungsfehler gefunden. Bitte gehen Sie zurück und korrigieren Sie die Eingaben.
                </MDBAlert>
              )}
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>

      {/* Validation Debug Info */}
      {isDevMode && (
        <MDBRow className="mb-4">
          <MDBCol>
            <MDBCard className="border-info">
              <MDBCardBody>
                <MDBTypography tag="h6" className="mb-3">
                  🔍 Validation Debug Info (Final Step - Dev Mode)
                </MDBTypography>
                
                <div className="mb-2">
                  <strong>Event:</strong> {eventConfig.eventId} ({eventConfig.eventType})
                </div>
                
                <div className="mb-2">
                  <strong>Form Ready to Save:</strong>{' '}
                  <MDBBadge color={isFormReadyToSave() ? 'success' : 'danger'}>
                    {isFormReadyToSave() ? 'Yes' : 'No'}
                  </MDBBadge>
                </div>
                
                <div className="mb-2">
                  <strong>Total Validation Errors:</strong> {validationSummary.totalErrors}
                </div>
                
                {!validationSummary.isValid && (
                  <div className="mb-2">
                    <strong>Errors by Step:</strong>
                    {Object.entries(validationSummary.errorsByStep).map(([stepId, errors]) => (
                      <div key={stepId} className="ms-3 mb-1">
                        <strong>{stepId}:</strong> {errors.length} error(s)
                      </div>
                    ))}
                  </div>
                )}
                
                <div className="mb-2">
                  <strong>Submit Button:</strong>{' '}
                  <MDBBadge color={isFormReadyToSave() ? 'success' : 'warning'}>
                    {isFormReadyToSave() ? 'Enabled' : 'Disabled'}
                  </MDBBadge>
                </div>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      )}

      </MDBContainer>
      
      {/* Fixed button container at bottom */}
      <div className="bg-white" style={{ 
        position: 'sticky', 
        bottom: 0,
        padding: '1rem',
        marginTop: 'auto',
        zIndex: 10
      }}>
        <MDBContainer>
          <MDBRow>
            <MDBCol className="d-flex justify-content-center gap-5">
              <MDBBtn color="secondary" onClick={goToPreviousStep} outline>
                {t('Back')}
              </MDBBtn>
              <MDBBtn 
                color={isFormReadyToSave() ? 'success' : 'warning'} 
                onClick={handleFinish}
                disabled={!isFormReadyToSave()}
              >
                {isFormReadyToSave() ? 'Anmeldung übermitteln' : 'Nicht bereit für Übermittlung'}
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </div>
  );
}